import React from 'react'
import '../components/css/chaincold.css';
import { Col, Container, Row } from 'react-bootstrap';




import f1 from '../components/images/coldchain1.webp';
import f3 from '../components/images/coldchain2.webp';
// import f2 from '../components/images/coldchain3.webp';
// import f1 from '../components/images/Second part 1.png';
import f2 from '../components/images/Second Part 2.png';
// import f3 from '../components/images/Second Part 3.png';


import t1 from '../components/images/Transport Image.webp';
import t2 from '../components/images/USB DATA.webp';


import s1 from '../components/images/IMG (10).webp';
import s2 from '../components/images/IMG (11).webp';
import s3 from '../components/images/IMG (12).webp';
import s4 from '../components/images/IMG (13).webp';
import s5 from '../components/images/IMG (14).webp';
import s6 from '../components/images/IMG (15).webp';

import i1 from '../components/images/Icon 1.webp';
import i2 from '../components/images/Icon 2.webp';
import i3 from '../components/images/Icon 3.webp';
import i4 from '../components/images/Icon 4.webp';

// import i1 from '../components/images/Controlled Storage.png';
// import i2 from '../components/images/Refrigerated.png';
// import i3 from '../components/images/Real Time.png';
// import i4 from '../components/images/Integrity.png';


import gg from '../components/images/Sider.png';

import { Button } from '@mui/material';


const ColdChain = () => {


    return (
        <>
            <section className="coldchain-section-mgt">

                <div className="cold-chain-section-page">
                    <div className="overlay">

                    </div>
                </div>
            </section>


            <div className="our-ficility-and-ccmgt">
                <Container>
                    {/* Title and Description */}
                    <Row className="text-center">
                        <Col>
                            <h1 className="title uppercase ">Cold Chain Management-Safeguarding Product Integrity</h1>
                            <p className="description text-center mt-3">
                                At Panav Biotech, we understand that the effectiveness of veterinary pharmaceuticals depends on strict temperature control. Our state-of-the-art cold chain management system ensures that every product maintains its required storage condition from manufacturing to the end-user.
                            </p>
                        </Col>
                    </Row>

                    {/* Image Section */}
                    <Row className="image-section">
                        <Col xs={12} md={4}>
                            <img src={f1} alt="Facility 1" className="facility-image" loading='lazy' />
                        </Col>
                        <Col xs={12} md={4}>
                            <img src={f3} alt="Facility 2" className="facility-image" loading='lazy' />
                        </Col>
                        <Col xs={12} md={4}>
                            <img src={f2} alt="Facility 3" className="facility-image" loading='lazy' />
                        </Col>
                    </Row>

                    {/* Footer Text */}
                    <Row>
                        <Col>
                            <p className="para-footer-ccmgt">Cold Room Facility for Storage of Veterinary Biologicals</p>
                        </Col>
                    </Row>
                </Container>
                <div className="footer-text"></div>
            </div>



            <div className="transport-ccmst-section">
                <Container fluid>
                    <Row className='align-items-center'>
                        <Col md={8} xs={12} className='align-items-center'>
                            <Row className="align-items-centerr justify-content-center mt-4">
                                {/* Transport Section */}
                                <Col xs={12} md={4} className="text-left text-md-left transport-section">
                                    <img src={t1} alt="Transport" className="section-image" loading='lazy' />
                                    <h3 className="section-title">TRANSPORT</h3>
                                    <p className="section-description">
                                        We use refer vehicles to transport our products. These vehicles are specially designed for transportation
                                        of temperature-sensitive products.
                                    </p>
                                    <ul className="list-disc list-inside ">
                                        <li> 24x7 Visibility</li>
                                        <li> Fastest transit time</li>
                                        <li> Backup power provided in case of emergencies.</li>
                                    </ul>
                                </Col>

                                {/* USB Temperature Data Loggers Section */}
                                <Col xs={12} md={4} className="text-center text-md-left usb-logger-section">
                                    <img src={t2} alt="USB Logger" className="section-image" loading='lazy' />
                                    <h3 className="section-title">USB TEMPERATURE DATA-LOGGERS</h3>
                                    <p className="section-description">
                                        Data loggers play a very important role in monitoring and recording the temperature of vaccines
                                        during transportation for safeguarding patients and vaccine potency.
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4} xs={12}>
                            <img src={gg} className='genrator-img' alt='' loading='lazy' />
                        </Col>
                    </Row>

                </Container>
            </div>






            <section className=" py-5">
                <div>
                    {/* Features Section */}
                    <Row className="text-center justify-content-center align-center mb-4 bg-[#233b77] ">
                        <Col xs={6} md={3} className="our-supply-ccmgt-section-page-feature flex justify-center items-center flex-col py-4">
                            {/* <FaClipboardCheck size={40} className="text-primary mb-2" /> */}
                            <img src={i1} alt="Feature 1" className="feature-image" loading='lazy' />
                        </Col>
                        <Col xs={6} md={3} className="our-supply-ccmgt-section-page-feature flex justify-center items-center flex-col py-4">
                            {/* <FaUpload size={40} className="text-primary mb-2" /> */}
                            <img src={i2} alt="Feature 2" className="feature-image" loading='lazy' />
                        </Col>
                        <Col xs={6} md={3} className="our-supply-ccmgt-section-page-feature flex justify-center items-center flex-col py-4">
                            {/* <FaFileExport size={40} className="text-primary mb-2" /> */}
                            <img src={i3} alt="Feature 3" className="feature-image" loading='lazy' />
                        </Col>
                        <Col xs={6} md={3} className="our-supply-ccmgt-section-page-feature flex justify-center items-center flex-col py-4">
                            {/* <FaFileExport size={40} className="text-primary mb-2" /> */}
                            <img src={i4} alt="Feature 4" className="feature-image" loading='lazy' />
                        </Col>

                    </Row>

                    {/* Description Section */}
                    <Row className="text-center">
                        <Col md={12}>
                            <h2 className=" text-[#233b77] font-extrabold text-3xl">OUR FACILITIES & COLD CHAIN MANAGEMENT</h2>
                            <p className="text-black mt-4 px-2">
                                Vaccines are sensitive biological products that are stored in cold chain chambers within WHO recommended temperature range to assure their quality. Vaccines exposed to temperature outside the recommended range can move reduced potency and protection.
                                <br />
                                <br />
                                Contingency plan for dealing with power cut. The recommended temperature to store vaccine is 2-8 degree Celsius and is facilitated 24 hours backups.
                            </p>

                        </Col>
                    </Row>
                </div>
            </section>


            <section className="banner-contact-section cursor-pointer"  >
                <div className="cold-chain-banner-background">
                    <Container fluid className="h-100">
                        <Row className="h-100 align-items-center">
                            <Col lg={12} md={12} className="text-end">

                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>


            <div className='flex justify-center items-center mt-2'>
                <Button variant="contained" className="btn-contact-ccmgt"
                    onClick={() => window.location = '/products'}
                >
                    Check Out Our Products
                </Button>
            </div>

            {/* <section className="snakshape-ccmgt-section-page-feature">
                <div className="snakeshape-ccmgt-container">
                    <div className="snakeshape-ccmgt-wave">
                        <img src={bg} alt="Background" />
                    </div>
                    <div className="snakeshape-ccmgt-items-elmnt">
                        <div className="snakeshape-ccmgt-item" style={{ left: "11%", top: "49%" }}>
                            <div className="snakeshape-ccmgt-circle">
                                <img src={s1} alt="Air Cargo" />
                            </div>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "42%", top: "47%" }}>
                            <div className="snakeshape-ccmgt-circle">
                                <img src={s2} alt="Distributor" />
                            </div>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "58%", top: "53%" }}>
                            <div className="snakeshape-ccmgt-circle">
                                <img src={s3} alt="Pet Hospital Or Clinics" />
                            </div>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "26%", top: "51%" }}>
                            <div className="snakeshape-ccmgt-circle">
                                <img src={s4} alt="Licensed Veterinary Doctors" />
                            </div>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "74%", top: "48%" }}>
                            <div className="snakeshape-ccmgt-circle">
                                <img src={s5} alt="Animal Husbandry Department" />
                            </div>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "89%", top: "48%" }}>
                            <div className="snakeshape-ccmgt-circle">
                                <img src={s6} alt="Headquarters Warehouse" />
                            </div>
                        </div>
                    </div>
                    <div className="snakeshape-ccmgt-items-elmnt">
                        <div className="snakeshape-ccmgt-item" style={{ left: "11%", top: "103%" }}>
                         
                            <p className="snakeshape-ccmgt-text">Air Cargo</p>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "42%", top: "103%" }}>
                          
                            <p className="snakeshape-ccmgt-text">Distributor</p>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "58%", top: "103%" }}>
                           
                            <p className="snakeshape-ccmgt-text">Pet Hospital Or Clinics</p>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "26%", top: "103%" }}>
                         
                            <p className="snakeshape-ccmgt-text">Licensed Veterinary Doctors</p>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "74%", top: "103%" }}>
                           
                            <p className="snakeshape-ccmgt-text">Animal Husbandry Department</p>
                        </div>

                        <div className="snakeshape-ccmgt-item" style={{ left: "89%", top: "103%" }}>
                         
                            <p className="snakeshape-ccmgt-text">Headquarters Warehouse</p>
                        </div>
                    </div>
                </div>
            </section> */}



        </>
    )
}

export default ColdChain
